import { render, staticRenderFns } from "./sellers-clients-management.modal.vue?vue&type=template&id=639e7880&scoped=true&"
import script from "./sellers-clients-management.modal.vue?vue&type=script&lang=js&"
export * from "./sellers-clients-management.modal.vue?vue&type=script&lang=js&"
import style0 from "./sellers-clients-management.modal.vue?vue&type=style&index=0&id=639e7880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e7880",
  null
  
)

export default component.exports